import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    height: PropTypes.string,
    width: PropTypes.string,
    color: PropTypes.oneOf(['primary', 'secondary']),
    shape: PropTypes.oneOf(['circle', 'rect']),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    color: 'secondary',
    height: '42px',
    shape: 'rect',
    width: '100%',
};

class Placeholder extends Abstrap {

    constructor(props) {
        super(props);
        const {
            width,
            height,
            style,
        } = this.props;
        this.placeholderStyle = {
            width,
            height,
            ...style,
        };
    }

    getClassNameSchema() {
        const {
            className,
            color,
            shape,
        } = this.props;
        return [
            'c-placeholder',
            `c-placeholder--${color}`,
            `c-placeholder--${shape}`,
            className,
        ];
    }

    render() {
        return (
            <this.props.componentClass
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.filterProps()}
                className={this.getClassName()}
                style={this.placeholderStyle}
            />
        );
    }

}

Placeholder.propTypes = propTypes;

Placeholder.defaultProps = defaultProps;

export default Placeholder;
